import React, { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import Api from "../../api/api";

const DevicesTable = ({ deviceList, fetchDeviceData }) => {
  const [deviceData, setDeviceData] = useState({ columns: [], rows: [] });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [newStatus, setNewStatus] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (Array.isArray(deviceList)) {
      setDeviceDataFromArray(deviceList);
    }
  }, [deviceList]);

  const setDeviceDataFromArray = (devicesArray) => {
    const columns = [
      { Header: "ID", accessor: "id", align: "left" },
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Device ID", accessor: "device_id", align: "left" },
      { Header: "Icon", accessor: "icon", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ];

    const rows = devicesArray.map((device, index) => ({
      id: index + 1,
      name: device.name,
      device_id: device.device_id,
      icon: (
        <img
          src={`https://iot.papayacoders.in/storage/app/public/${device.icon}`}
          alt={device.name}
          style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "8px" }}
        />
      ),
      status: (
        <span style={{ color: Number(device.status) === 1 ? "green" : "red" }}>
          {Number(device.status) === 1 ? "Active" : "Inactive"}
        </span>
      ),
      action: (
        <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
          <button
            onClick={() => openStatusModal(device)}
            style={{
              color: "#7b809a",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
            }}
            onMouseOver={(e) => (e.target.style.color = "#007bff")}
            onMouseOut={(e) => (e.target.style.color = "#7b809a")}
          >
            Update Status
          </button>
          <button
            onClick={() => handleDelete(device.id)}
            style={{
              color: "#dc3545",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
            }}

          >
            Delete
          </button>
        </div>
      ),
    }));

    setDeviceData({ columns, rows });
  };

  const openStatusModal = (device) => {
    setSelectedDevice(device);
    setNewStatus(Number(device.status));
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedDevice(null);
    setNewStatus(0);
    setLoading(false);
  };

  const handleUpdateStatus = async () => {
    if (!selectedDevice) return;

    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: `Change status for "${selectedDevice.name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    if (!confirmResult.isConfirmed) return;

    setLoading(true);
    try {
      await Api.updateDevices(selectedDevice.id, newStatus);
      await fetchDeviceData();
      closeModal();

      Swal.fire("Updated!", "Device status updated successfully.", "success");
    } catch (error) {
      console.error("Error updating status:", error);
      setLoading(false);
      Swal.fire("Error", "Failed to update device status.", "error");
    }
  };
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await Api.deleteDevices(id);
        Swal.fire("Deleted!", "Category has been deleted.", "success");
        fetchDeviceData();
      } catch (err) {
        console.error("Delete error:", err);
        Swal.fire("Error", "Something went wrong.", "error");
      }
    }
  };

  useEffect(() => {
    fetchDeviceData();
  }, []);
  return (
    <>
      <DataTable table={deviceData} canSearch showTotalEntries isSorted={false} />
      {modalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "20px",
              width: "320px",
            }}
          >
            <h3>Update Status for {selectedDevice?.name}</h3>
            <select
              value={newStatus}
              onChange={(e) => setNewStatus(Number(e.target.value))}
              style={{ width: "100%", padding: "8px", margin: "20px 0" }}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
            <button
              onClick={handleUpdateStatus}
              disabled={loading}
              style={{
                marginRight: "10px",
                padding: "8px 12px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Updating..." : "Update Status"}
            </button>
            <button
              onClick={closeModal}
              disabled={loading}
              style={{
                padding: "8px 12px",
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DevicesTable;
